import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { CookieService } from 'ngx-cookie-service';
import { FeatureHelperService } from '../../_helpers/feature-helper/feature-helper.service';

@Injectable({
  providedIn: 'root'
})
export class SessionUserHashManagerService {

  private currentSessionUserHash$: string = "";

  constructor(
    protected router: Router,
    private cookieService: CookieService,
    private featureHelperService: FeatureHelperService
    ) { }
  
  public setUserHash(user: any): void {
    let hash = this.generateHash(user);
    this.currentSessionUserHash$ = hash;
    this.cookieService.set("h", hash, null, '/', null, null, 'Lax');
  }
  
  public checkUser(): void {
    let loggedInUser = JSON.parse(localStorage.getItem('currentUser'));
    let loggedInUserHash = this.generateHash(loggedInUser);

    let currentSessionUserHash = this.getCurrentSessionUserHash();

    let cookie = this.cookieService.get("h");
    if(currentSessionUserHash == null || currentSessionUserHash == "")
    {
      this.setUserHash(loggedInUser)
      currentSessionUserHash = this.getCurrentSessionUserHash();
    }

    if (cookie == null || cookie == "" || currentSessionUserHash == "") {
      // nobody is logged in
      return;
    } else if (cookie != currentSessionUserHash) {
      this.currentSessionUserHash$ = cookie;
      this.router.navigate(["/"]);
    } else if (cookie == currentSessionUserHash) {
      if (loggedInUserHash != cookie) {
        // someone is tampering with the cookie
        this.router.navigate(["/login"]);
      }
    }
  }

  public checkUserForExternal(): void {
    let loggedInUser = JSON.parse(localStorage.getItem('currentUser'));
    let loggedInUserHash = this.generateHash(loggedInUser);

    let currentSessionUserHash = this.getCurrentSessionUserHash();

    let cookie = this.cookieService.get("h");
    if(currentSessionUserHash == null || currentSessionUserHash == "")
    {
      this.setUserHash(loggedInUser)
      currentSessionUserHash = this.getCurrentSessionUserHash();
    }

    if (cookie == null || cookie == "" || currentSessionUserHash == "") {
      // nobody is logged in
      this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
    } else if (cookie == currentSessionUserHash) {
      if (loggedInUserHash != cookie) {
        // someone is tampering with the cookie
        this.router.navigate(['/login'], { queryParams: { returnUrl: window.location.pathname }});
      }
    } else if (cookie != currentSessionUserHash) {
      this.currentSessionUserHash$ = cookie;
    } 

    this.featureHelperService.setUserFeatures(loggedInUser.userFeatures);

  }

  public clearSessionHash(): void {
    this.currentSessionUserHash$ = "";
    this.cookieService.delete("h");
  }

  public validateHash(hash: string): boolean {
    let loggedInUser = JSON.parse(localStorage.getItem('currentUser'));
    let loggedInUserHash = this.generateHash(loggedInUser);

    let cookie = this.cookieService.get("h");

    return hash == loggedInUserHash && hash == cookie;
  }
  
  public getCurrentSessionUserHash(): string {
    return this.currentSessionUserHash$;
  }

  private generateHash(objectToHash: any): string {
    let base64Hash = "";
    if (objectToHash != null  && objectToHash != undefined) {
      let hashSalt: string = "STEPS/LEAP is revolutionary";
      // The token and refresh token are left out: renewing the session (TokenRefreshService) changes
      // both, and must not look like a different user to this tab or any other.
      const { token, refreshToken, ...userToHash } = objectToHash;
      base64Hash = CryptoJS.enc.Base64.stringify(CryptoJS.HmacSHA512(JSON.stringify(userToHash), hashSalt));
    }
    return base64Hash;
  }

}
